import axiosInstance from '../helpers/axiosInstance'

const base = `${process.env.REACT_APP_PLATFORM_URL}/api/v1/handheld/pairing`

// The backend upcases the code but its Redis key keeps the dash, so a
// hand-typed "abcd1234" or "ABCD 1234" 404s — and hand-typing is exactly what
// this page exists for when the QR can't be scanned. Strip everything that
// isn't alphanumeric and re-insert the dash at the known 4+4 boundary. Anything
// that isn't 8 characters is passed through upcased for the backend to reject
// on its own terms.
export const normalizeUserCode = raw => {
  const typed = String(raw ?? '').trim()
  const chars = typed.toUpperCase().replace(/[^A-Z0-9]/g, '')
  return chars.length === 8 ? `${chars.slice(0, 4)}-${chars.slice(4)}` : typed.toUpperCase()
}

// Looks up a pending HandHeld pairing request by its user_code.
export const lookupHandheldPairing = async user_code => {
  const res = await axiosInstance.get(`${base}/lookup`, { params: { user_code: normalizeUserCode(user_code) } })
  return res.data
}

// Claims a pending HandHeld pairing request, binding the device to the calling (self-service) user.
export const claimHandheldPairing = async user_code => {
  const res = await axiosInstance.post(`${base}/claim`, { user_code: normalizeUserCode(user_code) })
  return res.data
}
